import classnames from "classnames";
import Panel from "components/shared/Panel/Panel";
import React from "react";
import { StyledComponentsPolymorphicProp } from "utils/commonTypes";

interface Props {
  isMiniTile?: boolean;
  className?: string;
  as?: StyledComponentsPolymorphicProp;
  children: React.ReactNode;
}

/**
 * A react wrapper component for the Bulma tile child class, styled as a Panel.
 *
 * Use with TileParent and TileRowContainer.
 */
const TileChild: React.FC<Props> = ({
  isMiniTile,
  className,
  as,
  children,
}) => (
  <Panel
    className={classnames("tile is-child", className)}
    isMiniTile={isMiniTile}
    as={as}
  >
    {children}
  </Panel>
);

export default TileChild;
